export const EXECUTIVE_DIRECTOR_ACREDITATION = '/accreditationexecutive/accreditations';

export const DECISION_MAKING = '/accreditationexecutive/decisionmaking';

export const TECHNICAL_REVIEWER = '/technicalReviewer';

export const EXECUTIVE_DIRECTOR = '/accreditationExecutive';

export const TECHNICAL_ANALYSIS_REPORT = '/accreditationtechnical';